module.exports = __webpack_public_path__ + "static/img/pc-tipping-img.50f8dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc-tipping-img.png
// module id = dq/G
// module chunks = 1